/* LH | Gift bag upsell in the theme (Leon, 21.10.2026). Config and rules: snippets/lh-bag-upsell.liquid.
 *
 * - The block is rendered hidden and moved into the TeeInBlue form as the FIRST upsell block, above the
 *   print file check, the partner set and the set switch (or directly before #teeFormActions). It is
 *   re-positioned when TeeInBlue re-renders.
 *   Order of the blocks in the panel: gift bag, print file check, partner set, set switch, buttons (Leon, 23.10.2026). The anchor is the
 *   first of the blocks below us in DOM order, so two scripts never fight for the same spot (before
 *   23.10.2026 the partner set and this block both wanted the place right above the print file check
 *   and moved each other around many times per second, which looked like a flickering page).
 * - Shown only while the selected variant SKU starts with a prefix of a matching entry. Every variant
 *   change checks again and resets the choice to "none" when the bag list changes.
 * - window.lhBagTakesOver() tells assets/teeinblue-custom.js to hide the TeeInBlue bag fields while this
 *   block serves the product, so the customer never sees two bag fields.
 * - The bag is added only AFTER TeeInBlue has added the main product (TeeInBlue event, backup: a
 *   successful /cart/add that is not an upsell request). A pending flag adds it once per click.
 * - Quantity = pieces of the selected variant: ...BUNDLE3X = 3, a bundle without a number = 2, else 1.
 * - Two groups (Leon, 22.10.2026): bags and, when the entry has the optional field stands, stands
 *   ("Aufsteller"). Each group has its own choice; both go into the cart in one request, the bag with
 *   _cross_sell = bag, the stand with _cross_sell = stand, both with _bag_of = the main item's _customization_id.
 * - Second item via the TeeInBlue cross-sell (Leon, 24.10.2026, socks): while TeeInBlue shows the cross-sell
 *   item as added (.tee-cross-sell-product-button--has-product), the entry's "pair" tiles join the bag group
 *   (e.g. 2 boxes for 2 pairs, cheaper than 2 x 1), with a 2x badge; the single tile then shows 1x. A pair tile
 *   goes into the cart with quantity 1. Removing the second item drops a chosen pair tile back to "none".
 * - Second item without pair tiles (Leon, 27.10.2026, bears): one bag per item, so while the second item is added
 *   every bag tile reads 2x with the double price and goes into the cart with quantity 2.
 * - Preview items (custom.addon_preview or field preview_skus, see the snippet) only show on non-main themes or
 *   with ?lh_preview=1.
 */
(function () {
  if (window.__lhBagLoaded) return;
  window.__lhBagLoaded = true;

  var NONE_ICON = '<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="21" fill="none" stroke="#141214" stroke-width="5"/><path d="M17.2 17.2l29.6 29.6" stroke="#141214" stroke-width="5" stroke-linecap="round"/></svg>';
  var KINDS = ['bags', 'stands'];
  var CROSS_SELL = { bags: 'bag', stands: 'stand' };
  var state = { sel: {}, entryKey: '', pending: false, timer: null, pairIds: {}, dbl: 1 };
  var PREVIEW_OK = (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') ||
    /[?&]lh_preview=1/.test(location.search);
  function visible(list) { return (list || []).filter(function (b) { return !b.preview || PREVIEW_OK; }); }
  function pairMode() { return !!document.querySelector('.tee-cross-sell-product-button--has-product'); }
  function anySelected() { return KINDS.some(function (k) { return !!state.sel[k]; }); }

  function root() { return document.querySelector('[data-lh-bag]'); }

  var config = null;
  function cfg() {
    if (config) return config;
    var el = document.querySelector('[data-lh-bag-config]');
    try { config = el ? JSON.parse(el.textContent) : null; } catch (e) { config = null; }
    return config;
  }

  function currentSku() {
    var c = cfg();
    if (!c) return '';
    var input = document.querySelector('form[data-type="add-to-cart-form"] .product-variant-id') ||
                document.querySelector('.product-variant-id');
    // ?variant= first: the TeeInBlue "available products" radio (angel wings 2er to 4er-Set) writes the URL but
    // leaves the theme's variant input on the single, so the input alone gave 1 bag for a 3er-Set (QA 27.10.2026).
    var fromUrl = new URLSearchParams(location.search).get('variant') || '';
    var id = c.variants[fromUrl] != null ? fromUrl : ((input && input.value) || '');
    var sku = c.variants[id];
    if (sku == null) { var keys = Object.keys(c.variants); sku = keys.length ? c.variants[keys[0]] : ''; }
    return String(sku || '');
  }

  function entry() {
    var c = cfg();
    if (!c) return null;
    var sku = currentSku();
    for (var i = 0; i < c.entries.length; i++) {
      var e = c.entries[i];
      if (!visible(e.bags).length && !visible(e.stands).length) continue;
      if (e.skus.some(function (p) { return sku.indexOf(p) === 0; })) return e;
    }
    return null;
  }

  function pieces() {
    var m = /BUNDLE(\d+)X/i.exec(currentSku());
    if (m) return Math.max(1, parseInt(m[1], 10));
    return /BUNDLE/i.test(currentSku()) ? 2 : 1;
  }

  window.lhBagTakesOver = function () { return !!entry(); };
  window.lhBagAllVariants = function () { var c = cfg(); return c ? c.all.map(String) : []; };

  // every Shopify money placeholder, so SEK ("{{amount_with_space_separator}} kr"), PLN, DKK etc. render too
  function formatMoney(cents) {
    var r = root();
    var fmt = (r && r.dataset.moneyFormat) || '{{amount_with_comma_separator}}€';
    function fmtNum(n, decimals, thousands, dec) {
      var parts = (Number(n) / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[0] + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmtNum(cents, 2, ' ', '.');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }

  function tile(kind, id, html, price, label, selected) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lh-bag__tile' + (selected ? ' is-selected' : '');
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', selected ? 'true' : 'false');
    b.setAttribute('aria-label', label);
    b.dataset.lhBagPick = id;
    b.dataset.lhBagKind = kind;
    b.innerHTML = '<span class="lh-bag__img">' + html + '</span><span class="lh-bag__price"></span>';
    b.querySelector('.lh-bag__price').textContent = price;
    return b;
  }

  function itemsOf(e, kind) { return visible(kind === 'stands' ? e.stands : e.bags); }

  function render() {
    var r = root();
    var e = entry();
    if (!r) return;
    if (!e) { if (!r.hidden) r.hidden = true; state.sel = {}; return; }
    var key = KINDS.map(function (k) { return itemsOf(e, k).map(function (b) { return b.id; }).join(','); }).join('|');
    if (key !== state.entryKey) { state.entryKey = key; state.sel = {}; }
    var box = r.querySelector('[data-lh-bag-groups]');
    var n = pieces();
    var pairs = pairMode() ? visible(e.pair) : [];
    // a second item but no pair tiles: one bag per item (bears, 27.10.2026)
    state.dbl = pairMode() && !pairs.length ? 2 : 1;
    state.pairIds = {};
    pairs.forEach(function (b) { state.pairIds[String(b.id)] = true; });
    // The second item was removed again: a chosen pair tile falls back to "none".
    if (state.sel.bags && !state.pairIds[state.sel.bags] &&
        !itemsOf(e, 'bags').some(function (b) { return String(b.id) === state.sel.bags; })) state.sel.bags = null;
    // Only rebuild when something changed, the MutationObserver calls this often.
    var sig = key + '|' + n + '|' + pairs.length + '|' + state.dbl + '|' + KINDS.map(function (k) { return state.sel[k] || ''; }).join(',');
    if (box.dataset.sig === sig && box.children.length) { r.hidden = false; return; }
    box.dataset.sig = sig;
    box.innerHTML = '';
    var headings = (cfg() && cfg().headings) || {};
    KINDS.forEach(function (kind) {
      var items = itemsOf(e, kind);
      if (!items.length) return;
      var group = document.createElement('div');
      group.className = 'lh-bag__group';
      var label = document.createElement('span');
      label.className = 'lh-bag__label';
      var hk = kind === 'bags' && e.heading === 'box' ? 'box' : kind;
      label.textContent = headings[hk] || '';
      var tiles = document.createElement('div');
      tiles.className = 'lh-bag__tiles';
      tiles.setAttribute('role', 'radiogroup');
      tiles.setAttribute('aria-label', headings[hk] || '');
      // screen reader name of the "none" tile in the shop language (was a German "Kein" everywhere, QA 26.10.2026)
      tiles.appendChild(tile(kind, '', NONE_ICON, '', ((cfg() && cfg().none) || {})[hk] || 'Kein', !state.sel[kind]));
      items.forEach(function (b) {
        var img = b.img ? '<img src="' + b.img + '" alt="" loading="lazy">' : '';
        // With pair tiles next to it, the single tile says 1x so the two choices read clearly (Leon, 24.10.2026).
        if (kind === 'bags' && pairs.length) img += '<span class="lh-bag__qty">1×</span>';
        var per = kind === 'bags' ? state.dbl : 1;
        if (per > 1) img += '<span class="lh-bag__qty">' + per + '×</span>';
        tiles.appendChild(tile(kind, String(b.id), img, '+' + formatMoney(b.price * n * per), b.name, state.sel[kind] === String(b.id)));
      });
      if (kind === 'bags' && pairs.length) {
        pairs.forEach(function (b) {
          var img = (b.img ? '<img src="' + b.img + '" alt="" loading="lazy">' : '') + '<span class="lh-bag__qty">2×</span>';
          tiles.appendChild(tile(kind, String(b.id), img, '+' + formatMoney(b.price), b.name, state.sel[kind] === String(b.id)));
        });
      }
      group.appendChild(label);
      group.appendChild(tiles);
      box.appendChild(group);
    });
    r.hidden = false;
  }

  // The first block below us that already sits in the TeeInBlue panel (same parent as the buttons):
  // every other upsell block comes after us.
  function anchor() {
    var actions = document.querySelector('#teeFormActions');
    if (!actions) return null;
    var parent = actions.parentElement;
    var list = [
      document.querySelector('.ck-datacheck--injected'),
      document.querySelector('[data-lh-partner]'),
      document.querySelector('[data-lh-set]'),
      actions
    ].filter(function (el) { return el && el.parentElement === parent; });
    list.sort(function (a, b) { return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
    return list[0] || actions;
  }

  function place() {
    var r = root();
    if (!r) return;
    var a = anchor();
    if (a && r.nextElementSibling !== a) a.insertAdjacentElement('beforebegin', r);
    render();
  }

  function track(name, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: name, lh_cross_sell: 'bag' };
      for (var k in (extra || {})) p[k] = extra[k];
      window.dataLayer.push(p);
    } catch (e) {}
  }

  async function addBag() {
    if (!state.pending) return;
    state.pending = false;
    clearTimeout(state.timer);
    var e = entry();
    if (!e || !anySelected()) return;
    var qty = pieces();
    // _bag_of = the main item's _customization_id (Agent QA 28.10.2026): the bag goes when its product goes
    // (assets/lh-partner-upsell-cart.js). The newest line with a design is the item TeeInBlue just added.
    var of = '';
    try {
      var cart = await (await fetch('/cart.js', { headers: { 'X-LH-Bag': '1' } })).json();
      var main = (cart.items || []).find(function (i) {
        var p = i.properties || {};
        return p._customization_id && !p._parent_customization_id && !p._partner_of;
      });
      of = main ? String(main.properties._customization_id) : '';
    } catch (err) {}
    var items = KINDS.filter(function (k) { return state.sel[k]; }).map(function (k) {
      var q = state.pairIds[state.sel[k]] ? 1 : qty * (k === 'bags' ? state.dbl : 1);
      var props = { _cross_sell: CROSS_SELL[k] };
      if (of) props._bag_of = of;
      return { id: Number(state.sel[k]), quantity: q, properties: props };
    });
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-LH-Bag': '1' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      items.forEach(function (it) {
        track('lh_bag_added', { lh_bag_variant: String(it.id), lh_bag_qty: it.quantity, lh_cross_sell: it.properties._cross_sell });
      });
      state.sel = {};
      render();
      setTimeout(function () {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;
        fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (s) { drawer.renderContents({ sections: s }); })
          .catch(function () {});
      }, 600);
    } catch (err) {
      console.error('[LH Bag] could not add bag', err);
    }
  }

  document.addEventListener('click', function (ev) {
    var pick = ev.target.closest && ev.target.closest('[data-lh-bag-pick]');
    if (pick) {
      ev.preventDefault();
      var kind = pick.dataset.lhBagKind || 'bags';
      state.sel[kind] = pick.dataset.lhBagPick || null;
      if (state.sel[kind]) track('lh_bag_selected', { lh_bag_variant: state.sel[kind], lh_cross_sell: CROSS_SELL[kind] });
      render();
      return;
    }
    var atc = ev.target.closest && ev.target.closest('.tee-btn--atc');
    if (!atc || !anySelected() || !entry()) return;
    var hasErrors = Array.prototype.some.call(document.querySelectorAll('.tee-required-message'),
      function (el) { return el.offsetParent !== null; });
    if (hasErrors) return;
    state.pending = true;
    clearTimeout(state.timer);
    state.timer = setTimeout(function () { state.pending = false; }, 15000);
  }, true);

  document.addEventListener('teeinblue-event-after-add-to-cart', function () { addBag(); });

  // Backup signal: a successful /cart/add of the main product (not one of the upsell requests).
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var headers = (init && init.headers) || {};
    var body = init && typeof init.body === 'string' ? init.body : '';
    var upsell = headers['X-LH-Bag'] === '1' || /_datacheck|_cross_sell|_partner_of/.test(body);
    var p = origFetch.apply(this, arguments);
    if (!upsell && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok && state.pending) setTimeout(addBag, 250); }).catch(function () {});
    }
    return p;
  };

  document.addEventListener('change', function () { setTimeout(place, 50); });

  function start() {
    place();
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      setTimeout(function () { busy = false; place(); }, 30); // not rAF: it never fires in a tab opened in the background
    }).observe(document.body, { childList: true, subtree: true });
    // TeeInBlue marks an added cross-sell item with a class only; check it once a second.
    var lastPair = pairMode();
    setInterval(function () { var p = pairMode(); if (p !== lastPair) { lastPair = p; render(); } }, 1000);
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
